import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
//import "./Special/special.css";
import Button from 'react-bootstrap/Button';
import PlayerCommentDisplayCard from './player_comment_display_card';
import CommentProcessCodeDesc from './datasets/comment_process_code_desc';
import DropDownOptionCard from '../shared-components/drop_down_option_card';


class PlayerFeedbackDisplayModal extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state={
        
    }    
    
}

handleChange(reviewCode){
    this.props.filterByReviewCode(reviewCode);
}

   
render() {
        this.playerCommentInfo = this.props.playerFeedback.map((playerFeedback, index) =>
          <PlayerCommentDisplayCard playerFeedback={playerFeedback}  key={index}  
           commentsOnly={this.props.commentsOnly}
           updateFeedback={this.props.updateFeedback}
           index={index}
           updatePlayerFeedback={this.props.updatePlayerFeedback}/>
              );

        
        const reviewTypeOptions = CommentProcessCodeDesc.map((optionsList,index) =>
            <DropDownOptionCard options={optionsList} key={index} />
        );
        
return <>
    <Modal className="text-center" show={this.props.openModal}  onHide={() => this.props.onClose()} 
       size="xl" scrollable="true" animation={false}>
        <Modal.Header className="backgroundTopBottom" closeButton>
            <Modal.Title>Player Comments - Number of Player Comment Records: &nbsp;
              {this.props.playerFeedback.length}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
              <div className="mt-2 text-left ml-3">
                  <label className={this.newAccountNbrClass} htmlFor="newAccountNbr">Review Code:&nbsp;&nbsp;
                  </label>             
                  <select value={this.state.newAccountNbr || "none"} name="newAccountNbr"
                      onChange={(val) => this.handleChange(val.target.value)}
                      className="btn btn-sm btn-outline-secondary dropdown-toggle" id="newAccountNbr">
                          {reviewTypeOptions}
                  </select>
                     
                  <table className="table">
                      <tbody>
                        <tr>
                          <th>User</th>
                          <th>Date and Time of Comment</th>
                          <th>Thumb Chosen</th>
                          <th>Comment</th>
                        </tr>
                        {this.playerCommentInfo}
                      </tbody>
                  </table>
              </div>
                  
        </Modal.Body>
        <Modal.Footer className="backgroundTopBottom p-0" >
              <Button variant="primary"  onClick={() => this.props.onClose()}>
                   Close
              </Button>
        </Modal.Footer>
       
    </Modal>
    
  </>
  }
}

export default PlayerFeedbackDisplayModal;